namespace GeniuzPOS.PosShift {
    export namespace ReportSaleTaxTreeTaxService {
        export const baseUrl = 'PosShift/ReportSaleTaxTreeTax';

        export declare function Create(request: Serenity.SaveRequest<ReportSaleTaxTreeTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportSaleTaxTreeTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportSaleTaxTreeTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportSaleTaxTreeTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/ReportSaleTaxTreeTax/Create",
            Update = "PosShift/ReportSaleTaxTreeTax/Update",
            Delete = "PosShift/ReportSaleTaxTreeTax/Delete",
            Retrieve = "PosShift/ReportSaleTaxTreeTax/Retrieve",
            List = "PosShift/ReportSaleTaxTreeTax/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportSaleTaxTreeTaxService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
